import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import moment from 'moment';

import './registerServiceWorker';

Vue.prototype.$http = axios;
//axios.defaults.baseURL = 'https://dev.johndivalovers.digital-noises.de/wp-json';
axios.defaults.baseURL = 'https://divalovers.com/wp-json';

Vue.config.productionTip = false;
Vue.mixin({
  data: function () {
    return {
      loadingData: false,
      animating:false,
      axiosIsActive: true,
      currentPostID: 0,
      currentSlug: 0,
      globalHost: "divalovers.com",
    }
  }
});
new Vue({
  axios,
  router,
  render: h => h(App),

}).$mount('#app');

  // watch: {
  //   router.beforeEach((to, from, next) => {
  //     console.log("watching route: " + to);
  //   });
  // }